module.exports = __webpack_public_path__ + "img/export-icon-with-bg-blue.70d39e21.svg";